import { valueFormater } from '@mercadoni/sinister/dist/cjs/shared/utils'
import { ParsePriceAggregate } from '~types/search'

interface SliderPriceAggregate {
  range: boolean
  marks: { [key: number]: string }
  rangeValue: number[]
  singleValue: number
  max: number
  min: number
  formatTooltip: (num: number) => string
  disabled: boolean
}

const parsePriceAggregate = ({
  buckets,
  defaultValue,
  currencyLocale,
  currencyFormat,
}: ParsePriceAggregate): SliderPriceAggregate => {
  const formatter = valueFormater(currencyLocale)({
    currency: currencyFormat?.currency,
    ...currencyFormat,
  })

  const formatTooltip = (num: number) => {
    return formatter(num).replace(' ', '')
  }

  let marks: { [key: number]: string } = {}
  let minValueFormatted = ''
  let maxValueFormatted = ''
  let maxSliderValue = 0
  let minSliderValue = 0

  const [{ min: minBucket, max: maxBucket }] = buckets

  const isRange = minBucket !== maxBucket
  const { gte = 0, lte = 0 } = defaultValue as { gte: number; lte: number }
  const gteValue: number = !gte ? minBucket : gte
  const lteValue: number = !lte ? maxBucket : lte
  minValueFormatted = formatter(minBucket).replace(' ', '')
  maxValueFormatted = formatter(maxBucket).replace(' ', '')

  if (isRange) {
    marks = {
      [minBucket]: `${minValueFormatted}`,
      [maxBucket]: `${maxValueFormatted}`,
    }
    maxSliderValue = maxBucket
    minSliderValue = minBucket
  } else {
    marks = {
      [minBucket]: `${minValueFormatted}`,
    }
    maxSliderValue = maxBucket
  }

  return {
    range: isRange,
    marks,
    rangeValue: [gteValue, lteValue],
    singleValue: minBucket,
    max: maxSliderValue,
    min: minSliderValue,
    formatTooltip,
    disabled: !isRange,
  }
}

export default parsePriceAggregate
